/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2025, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */

export class Consent {
	cookieName = 'policy_consent';
	dialog = null;

	constructor(element) {
		this.dialog = element;
		if (element) {
			this.init();
		}
	}

	init() {
		const self = this;
		this.dialog.querySelector('.btn-agree').addEventListener('click', function (evt) {
			self.accept();
			self.hide();
		});
		if (this.check()) {
			this.hide();
		} else {
			this.show();
		}
	}

	show() {
		this.dialog.show();
		//this.dialog.classList.remove('closed');
	}

	hide() {
		this.dialog.close();
		//this.dialog.classList.add('closed');
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		return parts.length < 2
			? undefined
			: parts
				.pop()
				.split(';')
				.shift();
	}

	setCookie(name, value, expiryDays, domain, path, secure) {
		let exdate = new Date();
		exdate.setHours(exdate.getHours() + ((expiryDays || 365) * 24));

		let cookie = [
			name + '=' + value,
			'expires=' + exdate.toUTCString(),
			'path=' + (path || '/')
		];

		if (domain) {
			cookie.push('domain=' + domain);
		}
		if (secure) {
			cookie.push('secure');
		}
		document.cookie = cookie.join(';');
	}

	check() {
		let now = (new Date());
		let data = this.getCookie(this.cookieName);
		if (!data) {
			return false;
		}
		try {
			data = JSON.parse(data);
			if (data && data.agree) {
				return true;
			}
		} catch (e) {
		}
		return false;
	}

	accept() {
		let value = JSON.stringify({
			agree: true,
			date: new Date()
		});
		this.setCookie(this.cookieName, value);
	}
}
export default Consent;
